declare global {
    interface Window { global: any; }
}

window.global = window.global || {};

export function Redirect(url:string): void {
    window.location.href = url;
}

export function Window() {
    return window;
}